type EngineModule = typeof import("./engine");

let pending: Promise<EngineModule> | null = null;

/**
 * Load (once) the three.js engine chunk. The 3D Render button calls this on
 * hover / focus for Premium users so the download overlaps the click. A
 * failed load (offline, deploy swapped chunks) is forgotten so a retry
 * can succeed.
 */
export function loadRender3dEngine(): Promise<EngineModule> {
  if (!pending) {
    pending = import("./engine").catch((err: unknown) => {
      pending = null;
      throw err;
    });
  }
  return pending;
}
